import React from 'react';

const OtherBanner = () =>  (
  <div className="flex w-36 max-w-[150px] desktop:w-1/2 py-2 px-4 bg-teal text-white text-md font-sourcesans">
    <p>Listed by Agent</p>
  </div>
)

export default OtherBanner;
